import { render, staticRenderFns } from "./ModalAskDPS.vue?vue&type=template&id=e6f21b16&"
import script from "./ModalAskDPS.vue?vue&type=script&lang=js&"
export * from "./ModalAskDPS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports